// src/theme/ThemeContext.jsx
import React, { createContext, useState, useMemo, useContext } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { getAppTheme } from './theme'; // دالة الثيم التي أنشأناها سابقاً

// 1. إنشاء الـ Context
export const ThemeModeContext = createContext({
  toggleColorMode: () => {},
  mode: 'light',
});

// 2. إنشاء المزود (Provider)
export const ThemeContextProvider = ({ children }) => {
  // يمكنك لاحقاً قراءة القيمة من localStorage لحفظ اختيار المستخدم
  const [mode, setMode] = useState('light');

  // دالة التبديل بين الوضعين (مغلفة بـ useMemo لتحسين الأداء)
  const colorMode = useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
      },
      mode,
    }),
    [mode]
  );

  // توليد الثيم بناءً على الوضع الحالي
  const theme = useMemo(() => getAppTheme(mode), [mode]);

  return (
    <ThemeModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        {/* CssBaseline يجب أن يكون هنا لضمان تطبيق خلفية الوضع الداكن على كامل الصفحة */}
        <CssBaseline />
        {children}
      </ThemeProvider>
    </ThemeModeContext.Provider>
  );
};

// 3. Hook مخصص لتسهيل استخدام الثيم في أي مكون
export const useThemeMode = () => useContext(ThemeModeContext);